import { BasicFrame } from 'components/organisms';
import { Button, Card, Spacer, Text, Title } from 'components';
import { fetchData } from '../../../api/fetchData';
import { frameConfigBasicAffiliateFlow } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { useNavigateOrigin } from '../../../hooks/useNavigateOrigin';
import { useTranslation } from 'react-i18next';
import { WarningYellowIcon } from 'components/icons';
import classes from 'classnames';
import layout from 'scss/layout.module.scss';
import styles from './RepeatedLoanRejected.module.scss';

export default function RepeatedLoanRejected() {
  const { navigateOrigin } = useNavigateOrigin();
  const i18Next = useTranslation();

  const onSubmit = () => {
    if (sessionStorage.getItem('token')) {
      try {
        fetchData('/token/invalidate', {
          method: 'delete',
        });
      } finally {
        sessionStorage.clear();
      }
    }
    navigateOrigin();
  };

  const content = getScreenTranslation(
    'affiliatesRepeatedLoanRejected',
    i18Next,
  );

  return (
    <BasicFrame
      {...frameConfigBasicAffiliateFlow}
      contentWrapperClassName={classes(layout['width-md'])}
    >
      <Card
        className={classes(
          styles.card,
          layout['flex-column-centered'],
          layout['full-width-border-box'],
        )}
      >
        <Title
          className={classes([styles.title])}
          icon={<WarningYellowIcon data-test="icon-warning" />}
          text={content.title}
          forceColumn
        />
        <Spacer marginTop="30px">
          <Text
            className={classes([styles['helper-text'], styles.opacity])}
            dangerouslySetInnerHTML={{ __html: content.msg1 }}
            dataTest="helper-text-1"
          />
        </Spacer>
        <Spacer marginTop="20px" marginBottom="8px">
          <Text
            className={styles['helper-text']}
            dangerouslySetInnerHTML={{ __html: content.msg2Strong }}
            dataTest="helper-text-2"
          />
        </Spacer>
        <Spacer marginBottom={{ default: '50px', s: '35px' }}>
          <Text
            className={classes([styles['helper-text'], styles.opacity])}
            dangerouslySetInnerHTML={{ __html: content.msg3 }}
            dataTest="helper-text-3"
          />
        </Spacer>
        <Button
          className={classes([styles['agreed-btn'], layout['width-sm']])}
          onClick={onSubmit}
          type="submit"
          dataTest="btn-submit"
        >
          {content.agreedBtn}
        </Button>
      </Card>
    </BasicFrame>
  );
}
